"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineCap = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
var LineCap;
(function (LineCap) {
    LineCap["Round"] = "round";
    LineCap["Square"] = "square";
})(LineCap || (exports.LineCap = LineCap = {}));
// import "./CircularProgress.css";
require("../styles/CircularProgress.css");
const CircularProgress = (props) => {
    return (react_1.default.createElement("div", { className: "metric-container-box" },
        react_1.default.createElement("div", { className: "metric-container-title" }, props.title),
        react_1.default.createElement("div", { className: "chart-container" },
            react_1.default.createElement("div", { style: { width: `${props.size}rem` } },
                react_1.default.createElement(material_1.Box, { sx: {
                        position: 'relative',
                        display: 'inline-flex',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } },
                    react_1.default.createElement(material_1.Box, { sx: {
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        } },
                        react_1.default.createElement(material_1.CircularProgress, { variant: "determinate", value: 100, sx: {
                                color: props.trackColor,
                            }, thickness: props.lineWidth, size: '100%' })),
                    react_1.default.createElement(material_1.CircularProgress, { variant: "determinate", value: props.progress, sx: {
                            [`& .${material_1.circularProgressClasses.circle}`]: {
                                strokeLinecap: props.lineCap,
                            },
                            color: props.color,
                        }, thickness: props.lineWidth, size: '100%' }),
                    react_1.default.createElement(material_1.Typography, { color: props.textColor, sx: {
                            fontSize: `${props.size / 4}rem`,
                            fontWeight: 700,
                            position: 'absolute',
                            fontFamily: `${props.textFont}`,
                        } }, props.text))))));
};
exports.default = CircularProgress;
